import * as S from "./Slider.style";

const ContentSlider = ({
    icon,
    map,
    alt,
    title,
    description,
    disclaimer,
    ...props
}) => {
    return (
        <S.ContentCard>
            <S.ContainerImage {...{
                src: map,
                alt: alt
            }}/>
            <S.CardInfo>
                <S.Icon {...{
                    src: icon,
                    alt: alt
                }} />
                <S.CardContainer>
                    <S.CardTitle variant='body02-sm'>{title}</S.CardTitle>
                    <S.Description variant='body02-sm'>{description}</S.Description>
                </S.CardContainer>
            </S.CardInfo>
            <S.Paragraph>{disclaimer}</S.Paragraph>
      </S.ContentCard>
    );
};

export default ContentSlider;